// extracted by mini-css-extract-plugin
module.exports = {"fact":"fact_fact__2BS2O","text":"fact_text__2QGrD","wide":"fact_wide__ZngV6"};